import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';

export function StickerEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["name"]} children={children} />
    );
}

export function StickerCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"sticker"} children={children} />
    );
}